import { getCurrentBoats as bts } from '../../language';
import { parseLengthParams, parsePageParams, parseSortParams } from '../boats';
import { getCurrentBoats } from '../../language';

// transform the match params from oem srp into normal makeModel
// match params = { brand: makeName, model: model-model1+model-model2}
// normal makeModel = { makeName: [model1, model2]}
const getMakeModelFromMatchParams = (brand, model = '') => {
  const makeModel = { [brand]: [] };
  if (model) {
    model.split('+').forEach((modelStr) => {
      const modelName =
        getCurrentBoats().SEARCH_URL_MODEL_PATTERN.exec(modelStr)[1];
      makeModel[brand].push(modelName);
    });
  }

  return makeModel;
};

export const getDefaultParams = (params) => {
  const makeModel = getMakeModelFromMatchParams(params.brand, params.model);
  const parsed = {
    ...parseLengthParams(params.length),
    ...parseSortParams(params.sort),
    ...parsePageParams(params.page, true),
    makeModel,
    brand: params.brand
  };
  const defaults = {
    ...bts().DEFAULT_REFINE_SEARCH
  };

  return {
    ...defaults,
    ...parsed
  };
};
